/*
 * Renton · Spärr i varukorgen. Byggd 2026-10-27.
 *
 * Gör två saker, båda när kunden försöker gå till kassan:
 *  1. Ensamma tillval. En rad som har egenskapen _tillval_till men som saknar
 *     grundprov i varukorgen plockas bort. Tillval ska inte gå att köpa
 *     separat.
 *  2. Offertprodukter. Vattenfilter säljs på offert utanför Shopify och ska
 *     aldrig kunna checkas ut. Rader med pris 0 eller produkttyp vattenfilter
 *     stoppas med ett meddelande.
 *
 * Borttagningarna körs en i taget. Shopifys cart-API tappar rader om flera
 * ändringar skickas parallellt, eftersom radnycklarna räknas om mellan anropen.
 *
 * Laddas globalt via snippets/renton-global.liquid.
 */
(function () {
  'use strict';

  var PROP = '_tillval_till';
  var MEDDELANDE_ID = 'renton-cart-guard-meddelande';

  function arTillval(rad) {
    return !!(rad.properties && rad.properties[PROP]);
  }

  function arOffert(rad) {
    if (rad.price === 0) return true;
    return String(rad.product_type || '').toLowerCase() === 'vattenfilter';
  }

  function hamtaVarukorg() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (svar) {
      return svar.json();
    });
  }

  function taBort(nyckel) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: nyckel, quantity: 0 })
    });
  }

  function taBortEnITaget(rader) {
    return rader.reduce(function (kedja, rad) {
      return kedja.then(function () {
        return taBort(rad.key);
      });
    }, Promise.resolve());
  }

  function visaMeddelande(text, nara) {
    var gammalt = document.getElementById(MEDDELANDE_ID);
    if (gammalt) gammalt.remove();

    var ruta = document.createElement('div');
    ruta.id = MEDDELANDE_ID;
    ruta.setAttribute('role', 'alert');
    ruta.textContent = text;
    ruta.style.cssText =
      'margin:12px 0;padding:12px 14px;border:1px solid #f3cdb4;border-radius:12px;' +
      'background:#fff4ec;color:#12313a;font-size:15px;line-height:1.45;';

    var plats = nara && nara.closest ? nara.closest('form') || nara.parentElement : null;
    if (plats) {
      plats.insertBefore(ruta, plats.firstChild);
    } else if (nara && nara.parentElement) {
      nara.parentElement.insertBefore(ruta, nara);
    } else {
      document.body.appendChild(ruta);
    }
    ruta.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function stadaOchKontrollera() {
    return hamtaVarukorg().then(function (varukorg) {
      var rader = varukorg.items || [];
      if (!rader.length) return { ok: true };

      var harGrundrad = rader.some(function (rad) {
        return !arTillval(rad);
      });
      var ensamma = harGrundrad ? [] : rader.filter(arTillval);

      if (ensamma.length) {
        return taBortEnITaget(ensamma).then(function () {
          return {
            ok: false,
            text:
              'Radon och PFAS för verksamheter beställs som tillval till provgrupp A eller B och kan inte köpas separat. Raden har tagits bort.',
            ladda_om: true
          };
        });
      }

      var offert = rader.filter(arOffert);
      if (offert.length) {
        return {
          ok: false,
          text:
            'Vattenfilter säljs på offert och kan inte betalas i kassan. Ta bort raden och skicka en offertförfrågan i stället, så hör vi av oss.'
        };
      }

      return { ok: true };
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target.closest('[name="checkout"], a[href^="/checkout"]');
      if (!el) return;
      if (el.getAttribute('data-renton-guard-ok') === 'ja') return;

      event.preventDefault();
      event.stopPropagation();

      stadaOchKontrollera()
        .then(function (resultat) {
          if (resultat.ok) {
            el.setAttribute('data-renton-guard-ok', 'ja');
            el.click();
            return;
          }
          visaMeddelande(resultat.text, el);
          if (resultat.ladda_om) {
            window.setTimeout(function () {
              window.location.reload();
            }, 2500);
          }
        })
        .catch(function () {
          el.setAttribute('data-renton-guard-ok', 'ja');
          el.click();
        });
    },
    true
  );
})();
